import { styled } from "@mui/material"

export const RowCellContainer = styled("div")(({ theme }) => ({
    whiteSpace: "pre-wrap",
    overflowWrap: "break-word",
    [theme.breakpoints.down("md")]: {
        width: "100%",
    },
}))
